export default {
  path: ":alias/aboutSettings",
  component: resolve => require(["@/views/about-settings"], resolve),
  children: [
    {
      path: "form",
      component: resolve => require(["@/views/about-settings/form"], resolve)
    }
  ]
};
